import {useEffect} from 'react';
import {successAlert} from 'shared/tools';

export default function useQueryAlert(key = 'alert') {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = params.get(key);

    if (!message) return;

    successAlert(message);
    params.delete(key);

    const newUrl = `${window.location.pathname}${params.size ? `?${params}` : ''}`;

    window.history.replaceState(null, null, newUrl);
  }, [key]);
}
